module.exports = __webpack_public_path__ + "img/Animals.b1a30d3d.jpg";